<div class="ticket-attribute">
  <div class="new-button">
    <app-button
      [matMenuTriggerFor]="chooseMenu"
      [icon]="'note_add'"
      [customColor]="'green'"
      [fontSize]="24"
    ></app-button>
    <mat-menu class="menu-for-status" #chooseMenu="matMenu" xPosition="before">
      <div class="ticket-delete-title">Attribútum típusa</div>
      <div
        class="ticket-accept-option"
        (click)="openModal()"
      >Normál</div>
      <div
        class="ticket-accept-option"
        (click)="openModal(undefined, true)"
      >Arcgis</div>
    </mat-menu>
  </div>
  <div *ngFor="let item of ticketAttributes;" class="ticket-attribute-container">
    <div class="title">
      <div>Név: {{item.name}}</div>
      <app-button
        (click)="openModal(item)"
        [icon]="'edit'"
        [customColor]="'yellow'"
      ></app-button>
      <app-button
        [icon]="'delete'"
        [customColor]="'red'"
        [matMenuTriggerFor]="delMenu"
      ></app-button>
    </div>
    <mat-menu class="menu-for-delete" #delMenu="matMenu" xPosition="before">
      <div class="ticket-delete-title">Biztosan törli?</div>
      <div
        class="ticket-delete-option"
        (click)="del(item)"
      >Igen</div>
      <div
        class="ticket-delete-option"
      >nem</div>
    </mat-menu>
    <div *ngIf="!item.auto">Lehetséges értékek:</div>
    <div *ngIf="!item.auto" class="attribute-container">
      <div class="attributes" *ngFor="let val of item.possibleValues">{{val}}</div>
    </div>
    <div *ngFor="let ext of item.ticketAttributeExtensions">{{ext.externalLayer.url}} | {{ext.argisAttributeName}}</div>
    <div class="other">
      <div *ngIf="!item.auto" >Kötelezően kitöltendő</div>
      <mat-slide-toggle *ngIf="!item.auto" [checked]="item.otherEnabled === 0" [disabled]="true"></mat-slide-toggle>
      <div>Kereshető</div>
      <mat-slide-toggle [checked]="item.searchable" [disabled]="true"></mat-slide-toggle>
      <div *ngIf="!item.auto" >Több válaszos</div>
      <mat-slide-toggle *ngIf="!item.auto" [checked]="item.multi" [disabled]="true"></mat-slide-toggle>
      <div>Dátum</div>
      <mat-slide-toggle [checked]="item.isDate" [disabled]="true"></mat-slide-toggle>
      <div *ngIf="item.auto">Kiemelt</div>
      <mat-slide-toggle *ngIf="item.auto" [checked]="item.isArcgis" [disabled]="true"></mat-slide-toggle>
    </div>
  </div>
</div>
